export default __webpack_public_path__ + "static/media/Templat1.702104af.png";